import { useEffect, useState } from "react";

export default function useLocalStorageForm(
  defaultValue,
  key,
  type = "create"
) {
  const [value, setValue] = useState(() => {
    if (type === "create") {
      const stickyValue = window.localStorage.getItem(key);
      if (
        stickyValue !== null &&
        stickyValue !== undefined &&
        stickyValue !== "undefined"
      ) {
        return JSON.parse(stickyValue);
      } else {
        return defaultValue;
      }
    } else {
      return defaultValue;
    }
  });

  const memoizedLocalStorage = () => {
    window.localStorage.setItem(key, JSON.stringify(value));
  };

  useEffect(() => {
    memoizedLocalStorage();
  }, [key, value]); // eslint-disable-line react-hooks/exhaustive-deps
  return [value, setValue];
}
